// extracted by mini-css-extract-plugin
export default {"tabs":"tabs--ehHts","tab":"tab--LW4pa","active":"active--ld5Hy"};